import axios from 'axios'
import { API_BASE_URL } from '../globalVar'

export const checkmendService = {
    getSearchesForClaim,
    search
}

function getSearchesForClaim(payload) {
    return axios.get(API_BASE_URL + `/api/admin/v1/recipero/${payload}/searches`)
}

function search(payload) {
    return axios.post(API_BASE_URL + '/api/admin/v1/recipero/search', payload);
}